// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"962519aa","453":"f8956705","775":"10ff7785","787":"e8ca5ca5","795":"9c7e4ce8"}[chunkId] + ".chunk.js";
};